import { useState, useCallback } from 'react';
import { getNodeContext } from '@/services/api';
import type { NodeContext } from '@/types/node';

export function useNodeContext() {
  const [context, setContext] = useState<NodeContext | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchContext = useCallback(async (nodeId: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await getNodeContext(nodeId);
      setContext(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch node context'));
    } finally {
      setLoading(false);
    }
  }, []);

  const clearContext = useCallback(() => {
    setContext(null);
    setError(null);
  }, []);

  return { context, loading, error, fetchContext, clearContext };
}
